import { Button } from '@/components/ui/button'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { Controller, type Control } from 'react-hook-form'
import type { AbsenceImportFormValues } from '../types'

interface Props {
  control: Control<AbsenceImportFormValues>
  fileInputRef: React.RefObject<HTMLInputElement | null>
  fileInputKey: number
  selectedFile: File | null
  preparing: boolean
  onPrepare(): void
  onReset(): void
}

export function StepUpload({
  control,
  fileInputRef,
  fileInputKey,
  selectedFile,
  preparing,
  onPrepare,
  onReset,
}: Props) {
  const translations = useTranslate({
    selectFile: 'settings.absence.import.select-file',
    selectedFile: 'settings.absence.import.selected-file',
    fileHint: 'settings.absence.import.file-hint',
    uploadAndDetect: 'settings.absence.import.upload-and-detect',
    reset: 'common.reset',
  })

  return (
    <Controller
      control={control}
      name="selectedFile"
      render={({ field }) => (
        <div className="grid gap-3">
          <input
            key={fileInputKey}
            ref={fileInputRef}
            type="file"
            hidden
            accept=".xlsx,.xls,.xlsm,.csv"
            onChange={event => {
              field.onChange(event.target.files?.[0] ?? null)
            }}
          />

          <div className="flex flex-wrap items-center gap-3">
            <Button size="sm" onClick={() => fileInputRef.current?.click()}>
              {translations.selectFile}
            </Button>

            <span className="text-sm text-stone-700">
              {selectedFile
                ? `${translations.selectedFile}: ${selectedFile.name}`
                : translations.fileHint}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Button
              size="sm"
              disabled={!selectedFile || preparing}
              onClick={onPrepare}
            >
              {translations.uploadAndDetect}
            </Button>

            <Button variant="outline" size="sm" onClick={onReset}>
              {translations.reset}
            </Button>
          </div>
        </div>
      )}
    />
  )
}
